export const STRINGS = {
  it: {
    hero: {
      available: "Disponibile per Progetti",
      explore: "Scopri i Miei Lavori",
    },
    sections: {
      projects: {
        title: "Progetti",
        subtitle: "in Evidenza",
        description: "Selezione di progetti che fondono ingegneria e design.",
        viewProject: "Vedi Progetto",
        close: "Chiudi",
        appStore: "App Store",
        googlePlay: "Google Play",
        visitSite: "Sito",
        previousMedia: "Precedente",
        nextMedia: "Successivo",
        playVideo: "Riproduci video",
      },
      experience: {
        title: "Percorso",
        subtitle: "Professionale",
        description: "Un percorso evolutivo tra simulazione 3D e architetture backend.",
      },
      tech: {
        title: "Ecosistema",
        subtitle: "Tech",
        description: "Un ecosistema di strumenti per scalabilità e innovazione digitale.",
      },
      contact: {
        title: "Mettiamoci",
        subtitle: "in Contatto",
        description: "Hai un progetto in mente? Scrivimi per esplorare nuove possibilità.",
        nameLabel: "Nome",
        namePlaceholder: "Mario Rossi",
        emailLabel: "Email",
        emailPlaceholder: "mario@example.com",
        messageLabel: "Messaggio",
        messagePlaceholder: "Raccontami del tuo progetto...",
        button: "Invia Messaggio",
      },
      footer: {
        tagline: "Costruiamo qualcosa di epico.",
        copyright: "Soluzioni Digitali High-End",
      },
    },
  },
  en: {
    hero: {
      available: "Available for Projects",
      explore: "Explore My Work",
    },
    sections: {
      projects: {
        title: "Featured",
        subtitle: "Masterpieces",
        description: "A selection of projects that blend engineering and design.",
        viewProject: "View Project",
        close: "Close",
        appStore: "App Store",
        googlePlay: "Google Play",
        visitSite: "Website",
        previousMedia: "Previous",
        nextMedia: "Next",
        playVideo: "Play video",
      },
      experience: {
        title: "Professional",
        subtitle: "Journey",
        description: "An evolving path through 3D simulation and backend architectures.",
      },
      tech: {
        title: "Tech",
        subtitle: "Ecosystem",
        description: "An ecosystem of tools for scalability and digital innovation.",
      },
      contact: {
        title: "Get in",
        subtitle: "Touch",
        description: "Got a project in mind? Drop me a line to explore new possibilities.",
        nameLabel: "Name",
        namePlaceholder: "John Doe",
        emailLabel: "Email",
        emailPlaceholder: "john@example.com",
        messageLabel: "Message",
        messagePlaceholder: "Tell me about your project...",
        button: "Send Message",
      },
      footer: {
        tagline: "Let's build something epic.",
        copyright: "High-End Digital Solutions",
      },
    },
  },
};

export const PROJECT_FILTERS = [
  { value: "All", label: { it: "Tutti", en: "All" } },
  { value: "Games", label: { it: "Giochi", en: "Games" } },
  { value: "VR/AR", label: "VR/AR" },
  { value: "Digital Twin & Apps", label: "Digital Twin & Apps" },
  { value: "Web", label: "Web" },
];
